import { publicConfig } from '@public-config';

import { WorkspaceHelpers } from './WorkspaceHelpers';

const APP_ORIGIN = new URL(publicConfig?.urls.frontend ?? 'https://directenergypartners.com').origin;

export const resolveInternalRedirect = (input?: string | null, fallback = '/'): string => {
    if (typeof input !== 'string' || input.trim() === '') {
        return fallback;
    }

    let target: URL;
    try {
        target = new URL(input, APP_ORIGIN);
    } catch {
        console.warn(`Ignoring unparseable redirect URL: ${input}`);
        return fallback;
    }

    if (!isInternalOrigin(target.origin)) {
        console.warn(`Ignoring off-origin redirect URL: ${input}`);
        return fallback;
    }

    return target.pathname + target.search + target.hash;
};

const isInternalOrigin = (origin: string) => origin === APP_ORIGIN || WorkspaceHelpers.isWorkspace(origin);
